import { AttachmentUploader } from '@/shared/components/attachment-uploader'
import { LinkWithQuery } from '@/shared/components/link-with-query'
import { useGetAttachmentTypesQuery } from '@/store/services/attachment-type.service'
import { useUpdateEmployeeContractMutation } from '@/store/services/employee-contract.service'
import { useGetEmployeeAttachmentsQuery } from '@/store/services/employee.service'
import {
  Button,
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader
} from '@material-tailwind/react'
import { FiArrowLeft } from 'react-icons/fi'
import {
  createSearchParams,
  generatePath,
  useLoaderData,
  useNavigate
} from 'react-router-dom'
import { attachment, list } from '@/router/utils'

export const EmployeeUploadAttachments = () => {
  const [currentEmployee] = useLoaderData()
  const navigate = useNavigate()

  const { activeContract = {} } = currentEmployee

  const searchParams = createSearchParams({
    role_id: activeContract?.employeeRole?.id,
    per_page: 100
  })
  const { data: { attachmentTypes = [] } = {}, isLoading } =
    useGetAttachmentTypesQuery(`?${searchParams}`)

  const { data: attachments = [], refetch } = useGetEmployeeAttachmentsQuery(
    {
      id: currentEmployee.id,
      employeeContractId: activeContract?.id,
      perPage: 9999,
      recents: true
    },
    { skip: !activeContract?.id }
  )

  const [updateContractEmployee] = useUpdateEmployeeContractMutation()

  const onUpload = async (values) => {
    await updateContractEmployee({
      id: activeContract.id,
      attachments_attributes: values
    })
    refetch()
  }

  return (
    <Dialog size='lg' open={true}>
      <DialogHeader className='pb-0'>
        <LinkWithQuery to={attachment('employees', currentEmployee.id)}>
          <Button
            size='sm'
            className='w-fit flex items-center'
            variant='text'
          >
            <FiArrowLeft size='16px' className='mr-2' />
            Volver
          </Button>
        </LinkWithQuery>
      </DialogHeader>

      <DialogBody>
        {!isLoading && (
          <AttachmentUploader
            attachmentTypes={attachmentTypes}
            onUpload={onUpload}
            showLatestAttachments
            attachments={attachments}
          >
            {(handleSubmit) => (
              <Button
                className='w-fit'
                variant='outlined'
                onClick={handleSubmit}
              >
                Agregar documento
              </Button>
            )}
          </AttachmentUploader>
        )}
      </DialogBody>

      <DialogFooter>
        <LinkWithQuery to={list('employees')}>
          <Button
            variant='outlined'
            color='white'
          >
            Salir
          </Button>
        </LinkWithQuery>
      </DialogFooter>
    </Dialog>
  )
}
